<template>
  <div class="main">
    <GoBack :name="`常见问题`" :type="2" :path="`/mobile/my`"></GoBack>

    <div
      :class="['content-box', { 'content-active': active === index }]"
      v-for="(item, index) in list"
      :key="index"
      @click="changeActive(index)"
    >
      <div class="content-herder">
        <img class="wen" src="@/assets/mobile/image/my/wen.png" />
        <div class="name">{{ item.title }}</div>
        <img class="arrow" src="@/assets/mobile/image/my/w-arraw.png" />
      </div>

      <div class="p-list">
       <div v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import GoBack from "@/components/goBack";
import { getQuestions } from "@/api/mobile";
export default {
  data() {
    return {
      list: [
        {
          name: "如何参加商业调查？",
          pList: [
            {
              title: "商业调查主要有网站、邮件、微信等参与方式，具体说明如下：",
              indent: true,
              bottom: true,
            },
            {
              title:
                "A. 登录网站，点击网站导航部分的“调查中心”， 即可查看是否有您适合参加的商业调查。如果有的话，点击调查标题，即可参加 。",
            },
            {
              title: "B. 最及时的方式：每天登录 爱答卷，及时参与调查和活动。",
            },
            {
              title:
                "C. 在邮箱中查收我们的调查邀请邮件，通过邮件中的链接直接作答问卷。有时我们也会通过手机短信通知您参加。",
            },
          ],
        },
        {
          name: "为什么我很少收到调查邀请？",
          pList: [
            {
              title:
                "爱答卷几乎每天都会有新的商业调查发布，但每个商业调查都有其特定的参加条件，例如年龄、性别、地区、收入等等。所以并不是每个调查，都适合于您。我们只会挑选符合您本人条件的调查，邀请您参加。",
              indent: true,
              bottom: true,
            },
            {
              title:
                "友情提示：您填写的个人信息越详细越真实，参加商业调查的机会就越大。完成手机验证和邮箱激活，也将有助您获得更多的商业调查机会。",
            },
          ],
        },
        {
          name: "为什么有时回答了几题就中止了？",
          pList: [
            {
              title:
                "发给您的商业调查，符合您注册时填写的基本信息调查条件，但是在问卷中会有另外的甄别条件。如果您不符合这些甄别条件，就会被迫中止调查。另外，每个商业调查都有参加人数的限制，可能在您参加问卷的时候，系统已经回收了足够的问卷，这同样会导致您无法继续参加调查。 虽然您没能完成问卷，但是做为对您的感谢，系统将会奖励您10个金币。",
              indent: true,
            },
          ],
        },
        {
          name: "为什么有时完成调查没有奖励？",
          pList: [
            {
              title:
                "只要您是认真、诚实回答填写并完成问卷，请不用担心，每一个调查结束之后，我们都会统计未能正常加分的用户名单，进行补加金币操作。",
              indent: true,
            },
          ],
        },
        {
          name: "微信红包兑换规则",
          pList: [
            {
              title:
                "本次兑换红包包括5元微信红包/10元微信红包/30元微信红包/50元微信红包/100元微信红包，具体红包包含但不限于以上几种，兑换细则如下：",
              indent: true,
              bottom: true,
            },

            {
              title: "5元微信红包兑换规则",
            },
            {
              title:
                "1、仅限通过爱答卷微信公众号兑换，请关注爱答卷微信公众号。",
            },
            {
              title:
                "2、所兑换红包将会以红包形式发放到您兑换使用的微信账号，红包24小时内未领取，系统将会自动收回红包，并且会将金币自动返还到您的爱答卷账户。",
            },
            {
              title: "3、最终解释权归爱答卷所有",
              bottom: true,
            },

            {
              title: "10元微信红包/30元微信红包/50元微信红包/100元微信红包",
            },
            {
              title:
                "1、每天仅享受一次系统自动审核发放。系统会根据答题质量等因素会对会员每天仅享受一次系统自动审核发放，5分钟内到账。当天第二次兑换系统将转为由人工审核，统一至每周五至周天审核通过后发放。",
            },
            {
              title:
                "2、红包系统自动审核发放仅限信用值>=90%的用户（信用值=结束项目的质量审核通过率）。低于90%的用户不享受每天一次系统自动审核发放，统一由人工审核发放。",
            },
            {
              title:
                "3、仅限通过爱答卷微信公众号兑换，请关注爱答卷微信公众号。",
            },
            {
              title:
                "4、所兑换红包将会以红包形式发放到您兑换使用的微信账号，红包24小时内未领取，系统将会自动收回红包，并且会将金币自动返还到您的爱答卷账户。",
            },
            {
              title:
                "5、礼品有数量库存，会定期补货，当缺货时还请大家耐心等待。",
            },
            {
              title: "6、最终解释权归爱答卷所有。",
            },
          ],
        },
        {
          name: "任务审核不通过的原因有哪些？",
          pList: [
            {
              title:
                "1、雷同数据：同一用户的不同问题答案雷同，或多个用户答案相似度极高。",
            },
            {
              title: "2、开放题质量差：胡乱回复、文不对题等，导致数据不可用。",
            },
            {
              title: "3、答题质量差：在封闭题上胡乱作答，数据不可用。",
            },
            {
              title:
                "4、前后逻辑不符：在答卷过程中，前后回答内容有明显的矛盾，举例：前面说自己3个月内购买过牛奶，后面回答近期没有购买过牛奶。",
            },
            {
              title:
                "PS：以上行为会导致您不能获取奖励，情节严重者还将被拉黑；另外，如果发现用户有技术作弊的嫌疑，我们可能会采取法律手段进行追究。",
            },
          ],
        },
      ],
      active: null,
    };
  },
  components: { GoBack },
  methods: {
    changeActive(index) {
      if (index === this.active) {
        this.active = null;
      } else {
        this.active = index;
      }
    },
  },
  created() {
    getQuestions({ categoryId: 2 }).then((res) => {
      if (res.code === 200) {
        this.list = res.data.list;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8fa;
  .content-box {
    width: calc(100% - 30px);
    margin-left: 15px;
    max-height: 42px;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    overflow: hidden;
    margin-bottom: 12px;
    transition: max-height ease 0.75s;
    .content-herder {
      height: 42px;
      display: flex;
      align-items: center;
      position: relative;
      width: 100%;
      border-bottom: 1px solid #fff;
      box-sizing: border-box;
      .wen {
        width: 20px;
        height: 20px;
        margin-left: 7px;
      }
      .name {
        margin-left: 7px;
        color: #666666;
        font-size: 14px;
      }
      .arrow {
        position: absolute;
        width: 16px;
        height: 16px;
        right: 18px;
        transform: rotate(180deg);
        transition: transform ease 0.75s;
      }
    }
    .p-list {
      padding: 10px 9px;
      color: #232323;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .content-active {
    max-height: 500px;
    .content-herder {
      border-bottom: 1px solid #eaeaea;
      .arrow {
        transform: rotate(0deg);
      }
    }
  }
}
</style>